/*global window,document,theme,jQuery,WebFont,AOS,setInterval,clearInterval,console*/
/*eslint no-console: ["off"] */
window.theme = window.theme || {};

(function ($) {
	'use strict';

	var $ = jQuery;

	theme.init = function () {
		AOS.init({
			easing: 'ease-out-quad',
			once: true,
			offset: 60,
			disableMutationObserver: true
		});

		WebFont.load({
			typekit: {
				id: 'svi2gvn'
			}
		});

		theme.Menus = (function () {
			var $menuToggle = $('.menu-toggle'),
				$subMenuToggle = $('.menu li.menu-item-has-children > a');

			// Mobile menu toggle
			$menuToggle.click(function () {
				$('html').toggleClass('menu-open');
				$('nav').toggleClass('open');
			});

			// Sub-menu toggle
			$subMenuToggle.click(function () {
//				$otherSubMenuToggles = $subMenuToggle.not(this);
				$subMenuToggle.not(this).removeClass('open');
				$(this).toggleClass('open');
				$(this).next('.sub-menu').slideToggle(200);

				$('.menu li.menu-item-has-children .sub-menu').not($(this).next('.sub-menu')).slideUp(200);
			});
		}());


		// Prevent default on '#' anchors
		$('a[href="#"]').on('click', function (e) {
			e.preventDefault();
		});

		// Initialize Featherlight Gallery
		$('.gallery-item a').add($('.pages a')).featherlightGallery();
	};

	theme.loadImageSection = function ($container) {
		// Wait until images inside container have lazyloaded class
		function setAsLoaded() {
			$container.removeClass('loading loading--delayed').addClass('loaded');
		}

		function checkForLazyloadedImage() {
			return $container.find('.lazyloaded').length;
		}

		// If it has SVGs it's in the onboarding state so set as loaded
		if ($container.find('svg').length) {
			setAsLoaded();
			return;
		}

		if (checkForLazyloadedImage() > 0) {
			setAsLoaded();
			return;
		}

		var interval = setInterval(function () {
			if (checkForLazyloadedImage() > 0) {
				clearInterval(interval);
				setAsLoaded();
			}
		}, 80);
	};

	theme.handleForms = (function () {
		var $gfields = $('.gfield'),
			$nyp_cart = $('.nyp-product form.cart'),
			$nyp = $nyp_cart.find('.nyp'),
			$showAmountForm = $('<button class="basket-add-button js-show-amount-form"><i class="fas fa-gift"></i> Add to gift basket</button>');

		$gfields.each(function () {
			var $this = $(this),
				$inputs = $(this).find('input, textarea');

			// Check if inputs are filled on load
			if ($inputs.val()) {
				$this.addClass('is-filled');
			}

			// Add .is-filled if in focus or if text is in inputs
			$inputs.on('focusin focusout', function (e) {
				if (e.type == 'focusin' || $(this).val()) {
					$this.addClass('is-filled');
				} else {
					$this.removeClass('is-filled');
				}
			});
		});

//		$nyp_cart.before($showAmountForm);
//		$showAmountForm.on('click', function(e) {
//			$(this).hide();
//			$nyp_cart.addClass('is-open');
//		});

		$nyp.each(function () {
			var $label = $(this).find('label'),
//				labelText = $label.text().replace('/((.*))/', ''),
				$input = $(this).find('.input-text');

//			$label.text(labelText);
			$input.wrap( "<div class='input-text-wrapper'></div>" );
		})
	}());

	theme.handleScroll = (function () {
		var didScroll,
			lastScrollTop = 0,
			delta = 5,
			headerHeight = $('.site-header').outerHeight();

		$(window).scroll(function () {
			didScroll = true;
		});

		function hasScrolled() {
			var st = $(window).scrollTop();

			// Make sure they scroll more than delta
			if (Math.abs(lastScrollTop - st) <= delta) {
				return;
			}

			// If they scrolled down and are past the navbar, add class .nav-up.
			// This is necessary so you never see what is "behind" the navbar.
			if (st > lastScrollTop && st > headerHeight) {
				// Scroll Down
				$('.site-header').removeClass('nav-down').addClass('nav-up');
			} else {
				// Scroll Up
				if (st + $(window).height() < $(document).height()) {
					$('.site-header').removeClass('nav-up').addClass('nav-down');
				}
			}

			if ($(window).scrollTop() !== 0) {
				$('html').addClass('scrolled');
			} else {
				$('html').removeClass('scrolled');
			}

			lastScrollTop = st;
		}

		setInterval(function () {
			if (didScroll) {
				hasScrolled();
				didScroll = false;
			}
		}, 250);
	}());

	theme.faqs = (function () {
		var $faq = $('.faq'),
			$faqAnswer = $faq.find('.faq-answer'),
			$faqQuestion = $faq.find('.faq-question');

		$faqAnswer.hide();
		$faqQuestion.click(function () {

			// Expand or collapse this panel
			$(this).next().slideToggle(200);
			$(this).toggleClass('faq-open');

			// Hide the other panels
			$('.faq-answer').not($(this).next()).slideUp(200);
			$('.faq-question').not($(this)).removeClass('faq-open');
		});
	}());

	$(document).ready(function () {
		theme.init();
		theme.loadImageSection($('section.banner .content-wrapper'));
	});
}(theme.jQuery));